import { AvTableColumn, AvTableRow } from '../Interfaces/av-table-card.interface';

export function exportToCsv(filename: string, columns: AvTableColumn[], rows: AvTableRow[], translateFn: (key: string) => string): void {
  const csv = buildCsvSection(columns, rows, translateFn);
  triggerDownload(filename.endsWith('.csv') ? filename : `${filename}.csv`, csv);
}

export interface CsvSection {
  title: string;
  columns: AvTableColumn[];
  rows: AvTableRow[];
}

export function exportAllToCsv(filename: string, sections: CsvSection[], translateFn: (key: string) => string): void {
  const parts: string[] = [];

  for (const section of sections) {
    parts.push(`"${section.title.replace(/"/g, '""')}"`);
    parts.push(buildCsvSection(section.columns, section.rows, translateFn));
    parts.push('');
  }

  triggerDownload(filename.endsWith('.csv') ? filename : `${filename}.csv`, parts.join('\r\n'));
}

function buildCsvSection(columns: AvTableColumn[], rows: AvTableRow[], translateFn: (key: string) => string): string {
  const escape = (val: unknown): string => {
    const str = val === null || val === undefined ? '' : String(val);
    return `"${str.replace(/"/g, '""')}"`;
  };

  const headers = columns.map(c => escape(translateFn(c.label)));
  const keys = columns.map(c => c.key);
  const dataRows = rows.map(row => keys.map(k => escape(row[k])).join(','));

  return [headers.join(','), ...dataRows].join('\r\n');
}

function triggerDownload(filename: string, csv: string): void {
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
